import { make } from '../../utils/component'
import BaseClass from '../../application/BaseClass'
import NavbarVM from '../vms/NavbarVM'
import NavbarView from '../views/NavbarView'
import navbarStore from '../stores/navbarStore'

class NavbarController extends BaseClass {
  constructor(options = {}) {
    super(options)
    let store = options.store || navbarStore
    this.vm = NavbarVM.create({ store })
  }
}

export default make(NavbarController, NavbarView)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/navbarComponent.js